export default `
# Praktické informace

**Babysitting** - rodiče s dětmi jsou vítáni

Pro rodiče účastnící se konference s dětmi ve věku 0-10 let máme připravenou:

- samostatnou místnost s live přenosem konference
- animátory se spoustou logických a IQ her od 2 do 10 let
- zlevněný vstup do Vida centra (IQ park 20 metrů od hotelu)
- zvýhodněnou partnerskou vstupenku

**Ubytování**

Účastníci konference, kteří mají zájem o ubytování v místě konání akce, mohou využít slevu na ubytování a objednat si ubytování za zvýhodněnou konferenční cenu. 

Hotel Voroněž 1****

- dvoulůžkový pokoj v ceně 1.310 Kč
- jednolůžkový pokoj v ceně 1.150 Kč

Hotel Voroněž 2***

- dvoulůžkový pokoj v ceně 1.110 Kč
- jednolůžkový pokoj v ceně 950 Kč

**Stravování:**

Po oba konferenční dni jsme pro Vás zajistili obědy a v sobotu i večeři v hotelu Orea Voroněž 1 s výběrem ze dvou variant, jedna z nich je vegetariánská. Cena obědového menu je 200 Kč a cena večeře je 150 Kč.
`



// WEBPACK FOOTER //
// ./src/content/devdata/venue/text2.js